module.exports = __webpack_public_path__ + "assets/img/car06.a80941b1.jpg";